import { createAction } from '../redux'

//
//
//

export const SET_API_GENERIC_INVALID = 'APP_SECURITY::SET_API_GENERIC_INVALID'

export const setApiGenericInvalid = error => createAction(SET_API_GENERIC_INVALID, { error })
